'use client'

import type { ReactNode } from 'react'

type MainPaneProps = {
  children: ReactNode
}

export function MainPane({ children }: MainPaneProps) {
  return <main className="flex-1 min-w-[600px] bg-page overflow-hidden flex flex-col">{children}</main>
}
